/**
 * @module constants
 */

export default {
  ID_COLUMN_WIDTH: '10%',
  TITLE_COLUMN_WIDTH: '25%',
  STATE_COLUMN_WIDTH: '25%',
  PROJECT_COLUMN_WIDTH: '25%',
  DEADLINE_COLUMN_WIDTH: '15%'
};



// WEBPACK FOOTER //
// ./app/constants/orderStatusTable.js